import React from 'react';
import {useBreakpointValue} from '@spothero/ui';
import useConfig from './use-config';

const useMobileBreakPoint = (breakpointValue = 'tablet') => {
    const {isMobile} = useConfig();

    return useBreakpointValue(
        {base: true, [breakpointValue]: false},
        isMobile ? 'base' : breakpointValue
    );
};

export default useMobileBreakPoint;

export function WithMobileBreakpoint(Component) {
    const WithSmallMobileDeviceCompHOC = (props = {}) => {
        const isMobile = useMobileBreakPoint();

        return <Component {...props} isMobile={isMobile} />;
    };

    WithSmallMobileDeviceCompHOC.displayName = `WithMobileBreakpoint(${
        Component.displayName || Component.name || 'Component'
    }`;

    return WithSmallMobileDeviceCompHOC;
}
